import {
  ContentModalProps,
  useContentModal,
} from '../useContentModal/useContentModal'
import {
  CtaModalFooter,
  CtaModalFooterProps,
} from './components/CtaModalFooter'
export interface CtaModalProps
  extends Omit<ContentModalProps, 'footer'>,
    CtaModalFooterProps {
  content: React.ReactNode
}

export const useCtaModal = ({
  content,
  onPrimaryClick,
  onSecondaryClick,
  primaryButtonText,
  primaryButtonProps,
  secondaryButtonText,
  secondaryButtonProps,
  buttonsAlignment,
  hiddenOnError,
  ...props
}: CtaModalProps) => {
  return useContentModal({
    content,
    footer: (
      <CtaModalFooter
        onPrimaryClick={onPrimaryClick}
        onSecondaryClick={onSecondaryClick}
        primaryButtonText={primaryButtonText}
        primaryButtonProps={primaryButtonProps}
        secondaryButtonText={secondaryButtonText}
        secondaryButtonProps={secondaryButtonProps}
        buttonsAlignment={buttonsAlignment}
        hiddenOnError={hiddenOnError}
      />
    ),
    ...props,
  })
}
